import React from 'react';

const SidebarContext = React.createContext({
  collapsed: false,
  setCollapsed: () => {},
  activeKey: null,
  setActiveKey: () => {},
});

export default SidebarContext;
